module.exports = __webpack_public_path__ + "img/box-10-2.b031eb0e.png";